import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isUngated", "hasScope", "userPermissions"];
// @ts-expect-error Untyped import
import { trackSpecificPropertyEvent } from 'customer-data-sidebar/tracking/events';
import { CardActions } from 'commerce-contract-lib/features/association/CardActions';
import { _tracker } from 'customer-data-tracking/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
function handleTrackingAction(action) {
  trackSpecificPropertyEvent(_tracker, {
    action
  });
}
export default function ContractCardActionWrapper(props) {
  const {
      isUngated,
      hasScope,
      userPermissions
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(CardActions, Object.assign({}, restProps, {
    isUngated: isUngated,
    hasScope: hasScope,
    trackEvent: handleTrackingAction,
    "data-test-id": "ContractCardAction-DefaultAction",
    userPermissions: userPermissions
  }));
}